import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../core/winpresentation/SimplePresentationRunner";
import {DasUBoot} from "../DasUBoot";
import {gsap} from "gsap";
import {DasUBootSymbol, DasUBootSymbolStates} from "../reels/DasUBootSymbol";
import {isMysterySymbol} from "../reels/symbols/MysterySymbol";

/**
 * Created by jonas on 2021-03-10.
 */

export class xWaysReveal implements SimplePresentation {

    start(controller:SimplePresentationRunnerController):void {

        const tl:gsap.core.Timeline = gsap.timeline({onComplete:() => controller.finish()});

        for (let data of DasUBoot.model.clientData.xWays) {
            const symbolData = DasUBoot.reelView.reels[data.reel].model.getVisibleSymbolAt(data.position);
            const symbol = <DasUBootSymbol>symbolData.positionable;
            if (isMysterySymbol(symbol)) {
                tl.add(symbol.getStateAnimation(DasUBootSymbolStates.REVEAL), 0);
            }
        }


    }

    shouldRun():boolean {
        return DasUBoot.model.clientData.xWays.length > 0;
    }


}